module.exports = __webpack_public_path__ + "img/bindcard_content_bg_long.7bd3ae0b.png";